/* eslint-disable import/prefer-default-export */
import { IntlShape } from "react-intl";

import { BadgeColor } from "components/v2/Badge/Badge";
import { ProviderInviteStatus } from "../../../../constants";

type StatusOption = {
  color: BadgeColor;
  label: string;
};

type StatusOptions = {
  [key in typeof ProviderInviteStatus[keyof typeof ProviderInviteStatus]]: StatusOption;
};

export const getStatusOptions = (intl: IntlShape): StatusOptions => ({
  [ProviderInviteStatus.DELIVERED]: {
    color: "success",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.delivered",
      defaultMessage: "Delivered",
    }),
  },
  [ProviderInviteStatus.WON]: {
    color: "success",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.won",
      defaultMessage: "Won",
    }),
  },
  [ProviderInviteStatus.QUOTED]: {
    color: "brand",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.quoted",
      defaultMessage: "Quoted",
    }),
  },
  [ProviderInviteStatus.IN_PROGRESS]: {
    color: "success",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.inProgress",
      defaultMessage: "In progress",
    }),
  },
  [ProviderInviteStatus.LOST]: {
    color: "error",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.lost",
      defaultMessage: "Lost",
    }),
  },
  [ProviderInviteStatus.OPENED]: {
    color: "gray",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.opened",
      defaultMessage: "Opened",
    }),
  },
  [ProviderInviteStatus.INVITED]: {
    color: "gray",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.invited",
      defaultMessage: "Invited",
    }),
  },
  [ProviderInviteStatus.NOT_INVITED]: {
    color: "gray",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.notInvited",
      defaultMessage: "Not Invited",
    }),
  },
  [ProviderInviteStatus.DECLINED]: {
    color: "warning",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.declined",
      defaultMessage: "Declined",
    }),
  },
  [ProviderInviteStatus.CANCELED]: {
    color: "error",
    label: intl.formatMessage({
      id: "shipment-quotes.components.invitedProviders.canceled",
      defaultMessage: "Canceled",
    }),
  },
});

export const statusPriority: Record<typeof ProviderInviteStatus[keyof typeof ProviderInviteStatus], number> = {
  [ProviderInviteStatus.DELIVERED]: 1,
  [ProviderInviteStatus.WON]: 2,
  [ProviderInviteStatus.QUOTED]: 3,
  [ProviderInviteStatus.IN_PROGRESS]: 4,
  [ProviderInviteStatus.LOST]: 5,
  [ProviderInviteStatus.OPENED]: 6,
  [ProviderInviteStatus.INVITED]: 7,
  [ProviderInviteStatus.NOT_INVITED]: 8,
  [ProviderInviteStatus.DECLINED]: 9,
  [ProviderInviteStatus.CANCELED]: 10,
};
